<template>
  <main class="prescription">
    <div class="prescription-content">
      <img src="@/assets/images/eyecare-logo-colored.png" class="prescription-logo">
      <div class="prescription-title">Orientações</div>
      <p class="description">
        Estes são os doumentos compartilhados com você pelo paciente {{  attendance?.patient?.name }}.
      </p>
      <br />
      <p class="description">
        Após baixar o documento você pode valida-lo através do site <a href="https://validar.iti.gov.br/">validar.iti.gov.br</a>.
      </p>

      <div class="text-document">Selecione um documento para baixar e visualizar:</div>

      <div class="document-card-content">
        <div v-for="(doc, index) in docs.filter(doc => parseInt(doc?.type_id) !== 0)" :key="index" class="document-card" @click="openFile(doc)">
          <p v-if="parseInt(doc?.type_id) === 0 && doc?.attendance?.type === 'PRE_CONSULTATION'">
            Pré-consulta
          </p>
          <p v-else-if="doc?.length >= 2">
            {{ doc?.group_name }}
          </p>
          <p v-else-if="parseInt(doc?.type_id) >= 0">
            {{ typeDoc[doc?.type_id] }}
          </p>
          <p v-else>
            {{ doc?.custom_name ?? 'Arquivo' }}
          </p>
          <Download class="icon" />
        </div>
      </div>
      <div class="share-content">
        <b-form-input
          id="cell"
          autocomplete="off"
          v-model="cellphone"
          v-mask="['(##) #####-####', '(##) #####-####']"
          placeholder="Informe um número WhatsApp para compartilhar"
        />
        <b-button
          :disabled="!cellphone"
          variant="primary"
          @click="openWhatsApp()">
          Compartilhar
        </b-button>
        <b-button
          variant="outline-secondary"
          @click="copyText()">
          Copiar link
        </b-button>
      </div> 
    </div>
  </main>
</template>
  
<script>
import { getDocTypes, docsToShowOnEmail } from '@/utils/documentHelper.js'

export default {
  name: 'Login',
  metaInfo: {
    title: 'Eyecare - Documentos do paciente',
  },
  components: {
    Download: () => import('@/assets/icons/download.svg'),
  },
  data () {
    return {
      typeDoc: getDocTypes(),
      docsToShow: docsToShowOnEmail(),
      docs: [],
      attendance: null,
      cellphone: '',
    }
  },
  created() {
    this.getMedicalRecord(this.$route.params.attendanceid);
    this.getAttendanceFiles(this.$route.params.attendanceid);
  },
  methods: {
    getAttendanceFiles(attendance) {
      const loading = this.$loading.show()
      this.api.getAttendanceFiles(attendance)
      .then(res => {
        this.docs = res.data.filter(el => {
          return this.docsToShow.includes(this.typeDoc[el?.type_id])
        })
      })
      .catch(err => { console.log('ERR getAttendanceFiles => ', err)})
      .finally(() => { loading.hide() })
    },
    getDocUrl(path){
      const loading = this.$loading.show()
      this.api.getDocTemporaryUrl(path)
      .then(res => {
        window.location.href = res.data
      })
      .catch(err => { console.log('ERR getAttendanceFiles => ', err)})
      .finally(() => { loading.hide() })
    },
    openFile(file) {
      if(file) {
        this.getDocUrl(file.path)
      }
    },
    openPage() {
      window.open('https://validar.iti.gov.br/', '_blank')
    },
    copyText(){
      navigator.clipboard.writeText(process.env.VUE_APP_URL+'/receita-farmacia/'+this.$route.params.attendanceid);
      this.$toast.success('Link copiado com sucesso')
    },
    openWhatsApp() {
      const patientName = this.attendance?.patient?.name
      const whatsappNumber = this.cellphone.replace(/\D/g, '')
      let linkWhatsapp = `https://api.whatsapp.com/send?phone=55${whatsappNumber}
        &text=Olá, este é um link de acesso aos documentos do paciente ${patientName}, assinados pelo médico(a) responsável. Clique e acesse: `
        linkWhatsapp += `${process.env.VUE_APP_URL+'/receita-farmacia/'+this.$route.params.attendanceid}`

        window.open(linkWhatsapp, "_blank")
    },
    getMedicalRecord(attendanceId) {
      this.api.getAttendanceById(attendanceId)
      .then(res => {
        this.attendance = res.data 
        this.startTime = res.data.start_datetime
        this.patient = res.data?.patient?.name 
        this.professional = res.data?.professional
        this.getCheckTerms()
      })
      .catch(err => { console.log('ERR getAttendanceFiles => ', err)})
      .finally(() => {  })
    },
  }
}
</script>

<style lang="scss" scoped>
  .prescription {
    display: flex;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
    background: #f0f0f0;
    text-align: center;

    .success-message {
      width: 550px;
      background-color: var(--states-success-soft-green);
      border-radius: 8px;
      padding: 16px 26px;
      display: flex;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;
      margin: 4px 0 40px;

      .icon {
        width: 24px;
        height: 24px;
        margin-right: 24px;
        fill: var(--states-success);
      }
    }
    .error-message {
      width: 550px;
      background-color: #ffeae8;
      border-radius: 8px;
      padding: 16px 26px;
      display: flex;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;
      margin: 4px 0 40px;
    }
  }

  .line{
    border-top: 1px dashed var(--neutral-300);
    margin-bottom: 16px;
  }

  .prescription-logo {
    width: 123px;
    height: 24px;
    margin-bottom: 4rem;
  }

  .terms-content {
    max-width: 400px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    overflow-x: auto;
  }

  .prescription-content {
    max-width: 400px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 2rem;
    overflow-x: auto;
  }
  .prescription-title {
    font-family: 'Red Hat Display';
    font-weight: 500;
    font-size: 1.5rem;
    color: var(--dark-blue);
    margin-bottom: 20px;
  }
  .terms-description {
    font-size: 0.8rem;
    color: #7c7c7c;
  }
  .text-document {
    font-weight: 700;
    font-size: 15px;
    line-height: 24px;
    color: var(--dark-blue);
    margin-top: 1rem !important;
  }
  .file-container {
    display: flex;
    flex-direction: row;
    gap: 20px;

    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      color: var(--type-active);
      align-items: center;
      display: flex;
    }
  }
  .qrcode-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
  }
  .qrcode {
    align-items: center;
    justify-content: center;
    display: flex;
    width: 165px;
    height: 165px;
    border: 5px solid var(--neutral-200);
    border-radius: 8px;
  }
  .document-card-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    border: 1px dashed var(--neutral-300);
    border-radius: 8px;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }
  .document-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 60px;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding:0.75rem;
    cursor: pointer;
  }
  .icon {
    width: 24px;
    height: 24px;
    fill: var(--blue-500);
  }
  .doc-iframe {
    width: 100%;
    height: 100%;
  }
  .text-center {
    text-align: center;
  }
  .share-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 1rem;
    button {
      font-size: 14px !important;
    }
  }
</style>

  